export const UPDATE_SEARCH_RESULT_COUNT = "UPDATE_SEARCH_RESULT_COUNT";
export const RESET_SEARCH_RESULT_COUNT = "RESET_SEARCH_RESULT_COUNT";
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const UPDATE_SEARCH_TABLE_ITEMS = "UPDATE_SEARCH_TABLE_ITEMS";
export const RESET_SEARCH_TABLE_ITEMS = "RESET_SEARCH_TABLE_ITEMS";
export const UPDATE_SORTING_COLUMN = "UPDATE_SORTING_COLUMN";
export const UPDATE_DESCENDING_SORTING = "UPDATE_DESCENDING_SORTING";
export const UPDATE_EMPTY_FILTER_STATE = "UPDATE_EMPTY_FILTER_STATE";
export const UPDATE_SEARCH_TEXT = "UPDATE_SEARCH_TEXT";
export const UPDATE_SELECTED_CREATION_DATE_RANGE = "UPDATE_SELECTED_CREATION_DATE_RANGE";
export const UPDATE_CURRENT_PAGE_INDEX = "UPDATE_CURRENT_PAGE_INDEX";
export const SEARCH_API_CALL_NEEDED = "SEARCH_API_CALL_NEEDED";
export const UPDATE_SEARCH_REQUEST = "UPDATE_SEARCH_REQUEST";
export const UPDATE_FILTER_ITEM_COUNT = "UPDATE_FILTER_ITEM_COUNT";
export const UPDATE_SELECTED_STATE = "UPDATE_SELECTED_STATE";
export const UPDATE_SELECTED_PRIORITY = "UPDATE_SELECTED_PRIORITY";
export const UPDATE_SELECTED_INVENTORY_CATEGORY = "UPDATE_SELECTED_INVENTORY_CATEGORY";
export const UPDATE_SELECTED_PROJECT_TAG = "UPDATE_SELECTED_PROJECT_TAG";
export const UPDATE_SELECTED_SOURCE = "UPDATE_SELECTED_SOURCE";
export const UPDATE_SELECTED_DESTINATIONS = "UPDATE_SELECTED_DESTINATIONS";
export const UPDATE_SELECTED_TRACKING_STAGES = "UPDATE_SELECTED_TRACKING_STAGES";
export const UPDATE_SELECTED_NEED_BY_DATE_RANGE = "UPDATE_SELECTED_NEED_BY_DATE_RANGE";
export const UPDATE_ACTIVE_DRAWER = "UPDATE_ACTIVE_DRAWER";
export const UPDATE_SOURCE_LOCATION_NAMES = "UPDATE_SOURCE_LOCATION_NAMES";
export const UPDATE_PROJECT_TAG_OPTIONS = "UPDATE_PROJECT_TAG_OPTIONS";
export const UPDATE_DESTINATION_LOCATION_NAMES_MORE_FILTERS = "UPDATE_DESTINATION_LOCATION_NAMES_MORE_FILTERS";
export const UPDATE_INVENTORY_CATEGORY_OPTIONS = "UPDATE_INVENTORY_CATEGORY_OPTIONS";
export const UPDATE_SELECTED_SEGMENT_ID = "UPDATE_SELECTED_SEGMENT_ID";